import React, {
    createContext, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Typography from '../../components/Typography/CustomTypography';
import { Role } from '../../common/Constants';
import styles from '../../assets/jss/pages/userLayoutStyle';

const useStyles = makeStyles(styles);

export const MainContext = createContext();

const HeaderUser = (props) => {
    const {
        role,
        eventInfo,
    } = props;
    const classes = useStyles(props);
    const history = useHistory();
    const location = useLocation();
    const { shortName } = useParams();

    const displayBackGroundImage = location.pathname.indexOf('/home') >= 0
    || location.pathname.indexOf('/register-visitor') >= 0
    || location.pathname.indexOf('/register-exhibitor') >= 0
    || location.pathname.indexOf('/exhibitor_login') >= 0
    || location.pathname.indexOf('/visitor_login') >= 0;
    const useCustomColor = location.pathname.indexOf('/register-exhibitor') >= 0
    || location.pathname.indexOf('/exhibitor_login') >= 0;

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener('scroll', () => {
            const mybutton = document.getElementById('myBtn');
            if (mybutton) {
                if (window.pageYOffset > 200) {
                    mybutton.style.display = 'flex';
                } else {
                    mybutton.style.display = 'none';
                }
            }
        });
    });

    const handleBackHomePage = () => {
        switch (Number(role)) {
            case Role.organizer:
                history.push(`/${shortName}/organizer/home`);
                break;

            case Role.viewer:
                history.push(`/${shortName}/home`);
                break;

            default:
                break;
        }
    };

    return (
        <div
            className={displayBackGroundImage ? classes.background : classes.displayBackGroundImage}
            style={{ backgroundImage: eventInfo.image && displayBackGroundImage ? `url(${eventInfo.image})` : 'none' }}
        >
            <Box className={displayBackGroundImage ? classes.userLogo : classes.noImageLogo}>
                {(!eventInfo.layout_sidebar || (+role === Role.organizer)) && (
                    <Typography
                        className={classes.noImageBrand}
                        variant="h3"
                        color="danger"
                        bold
                        onClick={handleBackHomePage}
                        style={{ display: 'flex' }}
                    >
                        XPAND
                        <span
                            className={displayBackGroundImage ? classes.brand : classes.noImageBrand}
                            style={{ fontSize: '50%', position: 'absolute' }}
                        >
                            &reg;
                        </span>
                    </Typography>
                )}
            </Box>
        </div>
    );
};

HeaderUser.defaultProps = {
    role: 0,
    eventInfo: {},
};

HeaderUser.propTypes = {
    role: PropTypes.number,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default HeaderUser;
